import axios from 'axios';
import { 
    LIST_PAYMENT_PROOFS_API,
    APPROVE_PAYMENT_PROOF_API,
    REJECT_PAYMENT_PROOF_API,
    get_headers,
    UPLOAD_POP_URL
} from '@/utils/constants/constants';
import formatting_mixins from '@/utils/mixins/formatting_mixins';
import alert_mixin from '@/utils/mixins/alert_mixin';

export default {
  name: 'PaymentProofs',
  mixins: [formatting_mixins, alert_mixin],
  data: () => ({
      lead_id: null,
      invoice_id: null, // <-- new
      proofs: [],
      currentProofUrl: null,
      headers: get_headers(),
      // Add all missing properties:
      commentText: '',
      amount: '',
      commentModalProofId: null,
      commentAction: null,
      selected_files: [],
      preview_url: null,
      is_previewable: false,
      upload_loading: false
   }),
  mounted() {
    this.lead_id = this.$route.params.lead_id || this.$route.query.lead_id
    this.invoice_id = this.$route.query.invoice_id || null;
    if (!this.lead_id) {
      this.show_error('Missing lead or invoice ID.')
      return
    }
    this.fetch_proofs()
  },
  methods: {
    async get_payment_proofs(){
        return await axios.get(LIST_PAYMENT_PROOFS_API,{
            headers: this.headers,
            params: {lead_id: this.lead_id,
                      invoice_id: this.invoice_id}
        })
    },
    async fetch_proofs() {
        const resp = await this.get_payment_proofs();
        if (resp.data.status === 'success') {
          this.proofs = resp.data.data
        } else {
          this.show_error('Failed to load proof of payments')
        }
    },

    openProof(url) {
      this.currentProofUrl = url
    },

    formatDate(ts) {
      return this.format_date(ts)
    },

    openCommentModal(proofId, action) {
      this.commentModalProofId = proofId
      this.commentAction = action
      this.commentText = ''
      this.amount = ''
    },

    async submitComment() {
      if (!this.commentModalProofId || !this.commentAction) return

      // Add validation for amount when approving
      if (this.commentAction === 'approve' && (!this.amount || parseFloat(this.amount) <= 0)) {
        this.show_error('Please enter a valid amount for approval.')
        return
      }

      const url =
        this.commentAction === 'approve'
          ? APPROVE_PAYMENT_PROOF_API
          : REJECT_PAYMENT_PROOF_API

      try {
        await axios.post(
          url,
          {
            lead_id: this.lead_id,
            proof_id: this.commentModalProofId,
            review_comments: this.commentText,
            amount: this.amount
          },
          { headers: this.headers }
        )
        this.show_success(
          this.commentAction === 'approve'
            ? 'Proof Payment  approved.'
            : 'Proof Payment rejected.'
        )
        await this.fetch_proofs()
      } catch (e) {
        this.show_error(
          (this.commentAction === 'approve' ? 'Approve' : 'Reject') +
            ' failed: ' +
            (e.response?.data?.message || e.message)
        )
      }
    },

    handle_file_selection(evt) {
        this.selected_files = Array.from(evt.target.files);

        if (this.selected_files.length === 1) {
          this.handle_file_preview(this.selected_files[0]);
        } else {
          this.preview_url = null;
          this.is_previewable = false;
        }
    },

    handle_file_preview(file) {
        const ext = file.name.split(".").pop().toLowerCase();
        this.is_previewable =
          ["pdf", "jpg", "jpeg", "png"].includes(ext);
        this.preview_url = URL.createObjectURL(file);
    },

    clear_file_selection() {
        if (this.preview_url) URL.revokeObjectURL(this.preview_url);
        this.preview_url = null;
        this.is_previewable = false;
        this.selected_files = [];
    },

    async submit_payment_proof() {
    if (!this.selected_files.length || !this.lead_id) {
      return this.show_error(
        "Please select a PDF file and make sure a lead ID is present in session."
      );
    }

    // Validate that all selected files are PDFs
    const allPdfs = this.selected_files.every(file => {
        const ext = file.name.split(".").pop().toLowerCase();
        return ext === 'pdf';
    });

    if (!allPdfs) {
        return this.show_error("Only PDF files are allowed.");
    }

    const form_data = new FormData();
    form_data.append("lead_id", this.lead_id);

    this.selected_files.forEach((file) =>
      form_data.append("document", file)
    );

    this.upload_loading = true;
    try {
      const { data } = await axios.post(UPLOAD_POP_URL, form_data, {
        headers: {
          ...this.headers,
          "Content-Type": "multipart/form-data",
        },
      });

      if (data.status === "success") {
        this.show_success(
          `Uploaded ${this.selected_files.length} PDF file(s) successfully.`
        );
        this.clear_file_selection();
        this.fetch_proofs()
      } else {
        this.show_error(data.message || "Upload failed");
      }
    } catch (err) {
      const msg =
        err.response?.data?.message ||
        err.response?.data?.detail ||
        err.message;
      this.show_error(msg);
    } finally {
      this.upload_loading = false;
    }
}
  },
}